<div class="container-fluid">
  <header class="row mt-5 ms-3 me-3">
    <div class="col-12 col-md-12 col-lg-4 col-xl-2 col-xxl-1">
      <img src="../../../../assets/images/logo-blue@3x.png" style="width: 125px;">
    </div>
    <div class="col-12 col-md-12 col-lg-8 col-xl-10 col-xxl-11 step-container">
      <ul class="step step-md step-inline">
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">1</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre compte</h4>
            </div>
          </div>
        </li>
        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">2</span>
            <div class="step-content">
              <h4 class="step-title">Créez votre cabinet</h4>
            </div>
          </div>
        </li>

        <li class="step-item">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-soft-primary">3</span>
            <div class="step-content">
              <h4 class="step-title">Choisissez votre abonnement</h4>
            </div>
          </div>
        </li>
        <li class="step-item active">
          <div class="step-content-wrapper">
            <span class="step-icon step-icon-primary">4</span>
            <div class="step-content">
              <h4 class="step-title">Bienvenue dans Optitax!</h4>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </header>
</div>

<div class="d-flex align-items-center " style="height: 100%;min-height:100%;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 col-xl-5 order-md-2 mb-5 mb-md-0">

        <!-- Image -->
        <div class="text-center">
          <img alt="..." class="img-fluid"
               src="/frontend/projects/app/src/assets/images/creating_account.svg">
        </div>

      </div>
      <div class="col-12 col-md-6 col-xl-7 order-md-1 my-5">

        <div class="text-center">

          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">
            Activation de votre abonnement
          </h6>

          <!-- Heading -->
          <h1 class="display-4 mb-5">
            Votre abonnement est en cours d'activation...
          </h1>

          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <!-- Subheading -->
          <p class="text-muted mb-4">
            Vous allez être redirigé sous peu.
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
